// extracted by mini-css-extract-plugin
export default {"col_w1000":"index_col_w1000_5McF4","advancedListTeam":"index_advancedListTeam_XUTZi","pic":"index_pic_OmPlu","txt":"index_txt_ccc2l","space26":"index_space26_lR1oe"};